<template>
  <div class="ParticularDefeated">
    <DtList :orderId="orderId" @priceList="priceList"></DtList>
  </div>
</template>

<script>
import DtList from "../common/DtList";
export default {
  created() {
    this.orderId = localStorage.getItem("orderId");
  },
  data() {
    return {
      orderId: ""
    };
  },
  methods: {
    priceList(list) {
      this.$emit("priceList", list);
    }
  },
  components: {
    DtList
  }
};
</script>

<style scoped>
.ParticularDefeated {
  height: 100%;
}
</style>